<template>
  <div>
    <div
      id="teamServiceItemModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" />
          <div class="modal-body">
            <div class="row" v-if="permissionEditDriverService">
              <div class="col-sm-12">
                <div class="card">
                  <div
                    class="card-body"
                    style="
                      border-style: solid;
                      border-color: #c4c4c4;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="row" style="margin: 10px 0">
                      <div class="col-md-12">
                        <input
                          type="text"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="服務名稱"
                          v-model="serviceName"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pull-right" v-if="permissionEditDriverService">
              <button class="btn btn-primary" @click="addService">
                +增加服務篩選項目
              </button>
            </div>
            <template>
              <el-table
                :data="serviceList"
                v-loading="loading"
                style="width: 100%"
              >
                <!-- first col -->
                <el-table-column label="服務項目">
                  <template slot-scope="scope">
                    <el-input
                      :placeholder="scope.row.name"
                      v-model="scope.row.name"
                    />
                  </template>
                </el-table-column>
                <!-- second col -->
                <el-table-column label="勾選">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.isWebPageCallingCar">
                      是否為 LINE 網頁叫車選擇
                    </el-checkbox>
                    <el-checkbox
                      v-model="scope.row.isChoosingCarSelection"
                      :checked="
                        deleteInputData(
                          scope.$index,
                          scope.row.isChoosingCarSelection,
                        )
                      "
                    >
                      是否能選擇車輛
                    </el-checkbox>
                    <div v-if="scope.row.isChoosingCarSelection">
                      <el-input
                        type="number"
                        :min="0"
                        placeholder="平日倍數（請輸入數字)"
                        v-model="scope.row.multipleOfNormal"
                      />
                      <el-input
                        placeholder="尖峰倍數（請輸入數字)"
                        :min="0"
                        v-model="scope.row.multipleOfRush"
                      />
                      <el-input
                        placeholder="特殊節慶倍數（請輸入數字)"
                        :min="0"
                        v-model="scope.row.multipleOfFestival"
                      />
                    </div>
                  </template>
                </el-table-column>
                <!-- third col -->
                <el-table-column label="按鈕">
                  <template slot-scope="scope">
                    <button
                      class="btn btn-primary"
                      @click="updateService(scope.$index)"
                    >
                      更新服務項目
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="deleteService(scope.$index)"
                    >
                      移除服務項目
                    </button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Notification } from 'element-ui'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import CustomerizeService from '@/assets/js/libs/CustomerizeService'

const customerize = new CustomerizeService()

export default {
  props: ['permissionEditDriverService'],
  data() {
    return {
      serviceList: [],
      serviceName: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions('hail', {
      vx_fetchServiceList: 'fetchServiceList',
    }),
    async fetch() {
      try {
        this.loading = true
        await this.vx_fetchServiceList()
        this.serviceList = this.vx_serviceList.map((service) => {
          // set null value to false
          if (!service.isWebPageCallingCar) {
            service.isWebPageCallingCar = false
          }
          if (!service.isChoosingCarSelection) {
            service.isChoosingCarSelection = false
          }
          return service
        })
        return this.serviceList
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async updateService(index) {
      const result = await customerize.update(this.serviceList[index])
      if (result.success) {
        this.fetch()
        Notification({
          title: '更新成功',
          type: 'success',
        })
        BehaviorRecorder.record(
          '點擊',
          '服務浮動框',
          '更新服務' + this.serviceList[index].name,
        )
      } else {
        Notification({
          title: '更新失敗',
          message: result.message,
          type: 'error',
        })
      }
    },
    async addService() {
      BehaviorRecorder.record(
        '點擊',
        '服務浮動框',
        '新增服務' + this.serviceName,
      )
      if (this.serviceName === '') {
        Notification({
          title: '請輸入新增的服務項目',
          message: '請在服務名稱的欄位中填入新增的服務項目',
          type: 'warning',
        })
        return
      }
      const result = await customerize.create({
        name: this.serviceName,
        isWebPageCallingCar: false,
        isChoosingCarSelection: false,
        multipleOfNormal: 1,
        multipleOfRush: 1,
        multipleOfFestival: 1,
      })
      if (result.success) {
        this.serviceName = ''
        Notification({
          title: '新增服務成功',
          type: 'success',
        })
        this.fetch()
      } else {
        Notification({
          title: '新增服務失敗',
          message: '新增服務失敗，請稍後再試一次',
          type: 'error',
        })
      }
    },
    async deleteService(index) {
      BehaviorRecorder.record(
        '點擊',
        '服務浮動框',
        '移除服務' + this.serviceList[index].id,
      )
      const result = await customerize.delete({
        id: this.serviceList[index].id,
        team_id: this.serviceList[index].teamId,
      })
      if (result.success) {
        this.fetch()
        Notification({
          title: '刪除服務成功',
          type: 'success',
        })
      } else {
        Notification({
          title: '刪除失敗',
          message: '刪除失敗，請稍後再試一次',
          type: 'error',
        })
      }
    },
    deleteInputData(index, isCheck) {
      if (!isCheck) {
        this.serviceList[index].multipleOfRush = null
        this.serviceList[index].multipleOfNormal = null
        this.serviceList[index].multipleOfFestival = null
      }
    },
    showModal() {
      $('#teamServiceItemModal').modal('show')
      this.fetch()
    },
  },
  computed: {
    ...mapState('hail', {
      vx_serviceList: 'serviceList',
    }),
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/driver/components/ServiceListModal.vue